import { render } from "./OrderReferralPartners.vue?vue&type=template&id=d786c932"
import script from "./OrderReferralPartners.vue?vue&type=script&lang=js"
export * from "./OrderReferralPartners.vue?vue&type=script&lang=js"
script.render = render

export default script